import React from 'react';
import PropTypes from 'prop-types';
import CustomMenuField from 'Shared/form/CustomMenu';

const propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            medicationId: PropTypes.string.isRequired,
        }),
    }).isRequired,
};

const defaultProps = {};

function RowCustomMenu({ row }) {
    return (
        <CustomMenuField
            menuName="referral_medication_status_reason"
            fieldName={`medications.${row.original.medicationId}.status`}
            required
        />
    );
}

RowCustomMenu.propTypes = propTypes;
RowCustomMenu.defaultProps = defaultProps;

export default RowCustomMenu;
